import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const FrameContainerHeader = t0 => {
  const $ = _c(10);
  const {
    icon,
    subtitle,
    title
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = !!icon && <div className="FrameContainerHeader__icon">{icon}</div>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = !!title && <div className="text-center text-2xl font-bold text-white mt-4">{title}</div>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== subtitle) {
    t3 = !!subtitle && <div className="text-center text-white text-sm">{subtitle}</div>;
    $[4] = subtitle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="bg-brand-dark [background-image:url(https://joybird2.imgix.net/user-uploads-staging/joybird-teal-new.jpg?w=400&cs=srgb)] bg-cover items-center flex flex-col -mt-5 -mx-5 mb-10 px-8 py-6 md:rounded-none md:mt-[-41px] md:mx-[-41px] md:mb-10 md:pb-8">{t1}{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
FrameContainerHeader.propTypes = {
  icon: PropTypes.node,
  subtitle: PropTypes.node,
  title: PropTypes.node
};
export default FrameContainerHeader;